// DCA Enterprises Inc's own Google sign-in (shared by the main site and the challenge).
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const KEY = "dca_google_oauth";

export const googleRedirectUri = () => window.location.origin + "/auth/google";

export function startGoogleLogin(flow, next) {
  const state = window.crypto.randomUUID();
  sessionStorage.setItem(KEY, JSON.stringify({ state, flow, next }));
  const p = new URLSearchParams({
    client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    redirect_uri: googleRedirectUri(),
    response_type: "code",
    scope: "openid email profile",
    state,
    prompt: "select_account",
  });
  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${p}`;
}

export function readGoogleReturn() {
  const q = new URLSearchParams(window.location.search);
  let saved = null;
  try { saved = JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch { saved = null; }
  if (!saved || !q.get("code") || q.get("state") !== saved.state) return null;
  return { code: q.get("code"), flow: saved.flow, next: saved.next };
}

export const clearGoogleReturn = () => sessionStorage.removeItem(KEY);
